import { forwardRef } from 'react'

import { CustomSpinner } from '../CustomSpinner'

import { Container } from './styles'

export const IconButton = forwardRef(
  (
    {
      width,
      height,
      isLoading,
      isDisabled,
      color = '#0d6efd',
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <Container
        type="button"
        $width={width}
        $height={height}
        ref={ref}
        color={color}
        disabled={isLoading || isDisabled}
        {...rest}
      >
        {isLoading ? (
          <CustomSpinner
            color="white"
            size={20}
          />
        ) : (
          children
        )}
      </Container>
    )
  },
)
